/*
  Promo Floating Bar — cart-synced step discount + GWP gauge
*/
(function () {
  'use strict';

  var bar = document.getElementById('promoFloatingBar');
  if (!bar) return;

  // Hide bar after the final Time Attack checkout window (11/16 11:32 GMT+8)
  if (Date.now() >= new Date('2026-11-16T11:32:00+08:00').getTime()) { bar.style.display = 'none'; return; }

  // i18n — from shared promo-i18n.js
  var barLang = window.PROMO_LANG || 'en';
  var i18nAll = window.PROMO_I18N || {};
  var bt = i18nAll[barLang] || i18nAll['en'] || {};

  // Apply i18n to bar elements
  bar.querySelectorAll('[data-i18n-bar]').forEach(function (el) {
    var key = el.dataset.i18nBar;
    if (bt[key]) el.textContent = bt[key];
  });

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function fetchJson(path) {
    var rf = window.__foxThemeRawFetch || window.fetch;
    return rf(root + path).then(function (response) {
      if (!response.ok) throw new Error('Promotion request failed');
      return response.json();
    });
  }

  // Publish the catalogue only after every page succeeds. Retry on the next update.
  var promoIds = [];
  var promoIdsLoaded = null;
  var catalogueReady = false;
  function loadPromoIds() {
    if (catalogueReady) return Promise.resolve();
    if (promoIdsLoaded) return promoIdsLoaded;
    var allIds = [];
    function fetchPage(p) {
      return fetchJson('collections/the-biggest-11-11-all/products.json?limit=250&page=' + p)
        .then(function (data) {
          if (!Array.isArray(data.products)) throw new Error('Invalid promotion catalogue');
          var products = data.products;
          products.forEach(function (pr) { allIds.push(pr.id); });
          if (products.length === 250) return fetchPage(p + 1);
          promoIds = allIds;
          catalogueReady = true;
        });
    }
    promoIdsLoaded = fetchPage(1).catch(function (error) {
      promoIdsLoaded = null;
      throw error;
    });
    return promoIdsLoaded;
  }

  function isPromo(item) {
    return promoIds.indexOf(item.product_id) !== -1 || (item.handle && item.handle.indexOf('-time-attack') !== -1);
  }

  var TIERS = [
    { qty: 3, pct: 15 },
    { qty: 4, pct: 22 },
    { qty: 5, pct: 28 }
  ];
  var gwpUsd = parseInt(bar.dataset.gwpThresholdUsd || '120', 10);
  function getGwpThreshold() {
    var rate = (window.Shopify && window.Shopify.currency && parseFloat(window.Shopify.currency.rate)) || 1;
    return Math.trunc(Math.round(gwpUsd * 100) * rate);
  }

  var fillEl = bar.querySelector('[data-pfbar-fill]');
  var gaugeEl = bar.querySelector('[data-pfbar-gauge]');
  var nodes = bar.querySelectorAll('[data-node]');
  var steps = bar.querySelectorAll('[data-step-qty]');
  var discountBtn = bar.querySelector('[data-pfbar-discount]');
  var originalEl = bar.querySelector('[data-pfbar-original]');
  var totalEl = bar.querySelector('[data-pfbar-total]');
  var savedEl = bar.querySelector('[data-pfbar-saved]');
  var gwpFill = bar.querySelector('[data-pfbar-gwp-fill]');
  var gwpFillMo = bar.querySelector('[data-pfbar-gwp-fill-mo]');
  var gwpText = bar.querySelector('[data-pfbar-gwp-text]');
  var gwpTextMo = bar.querySelector('[data-pfbar-gwp-text-mo]');

  function formatMoney(cents) {
    var fmt = (window.FoxTheme && window.FoxTheme.settings && window.FoxTheme.settings.moneyFormat) || '${{amount}}';
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, fmt);
    }
    var val = cents / 100;
    var amountDot = val.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var amountComma = val.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var noDecDot = Math.round(val).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var noDecComma = Math.round(val).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return fmt
      .replace('{{amount_with_comma_separator}}', amountComma)
      .replace('{{amount_no_decimals_with_comma_separator}}', noDecComma)
      .replace('{{amount_with_apostrophe_separator}}', val.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, "'"))
      .replace('{{amount_no_decimals}}', noDecDot)
      .replace('{{amount}}', amountDot);
  }

  function getCurrentTier(qty) {
    for (var i = TIERS.length - 1; i >= 0; i--) {
      if (qty >= TIERS[i].qty) return TIERS[i];
    }
    return null;
  }

  function appliedPromotion(item) {
    var applied = { base: false, tier: 0 };
    var allocations = item.line_level_discount_allocations || [];
    allocations.forEach(function (allocation) {
      if (!(allocation.amount > 0)) return;
      var title = ((allocation.discount_application || {}).title || '').toUpperCase();
      if (/^THE BIGGEST 11\.11\s*:\s*TIME ATTACK EXTRA 11%OFF$/.test(title)) applied.base = true;
      TIERS.forEach(function (tier) {
        var pattern = new RegExp('^THE BIGGEST 11\\.11\\s*:\\s*BUY' + tier.qty + '\\s*,\\s*' + tier.pct + '%OFF$');
        if (pattern.test(title)) applied.tier = Math.max(applied.tier, tier.pct);
      });
    });
    return applied;
  }

  var updateGeneration = 0;
  var currentTier = null;
  var hasConfirmedCart = false;
  function update(event) {
    // Optimistic add/remove events are followed by the authoritative cart response.
    if (event && (event._optimistic || (event.cart && event.cart._optimistic))) return;
    var generation = ++updateGeneration;
    bar.setAttribute('aria-busy', 'true');
    if (!hasConfirmedCart) bar.setAttribute('hidden', '');
    updateBodyPadding();
    return loadPromoIds().then(function () { return fetchJson('cart.js'); })
      .then(function (cart) {
        if (generation !== updateGeneration) return;
        if (!Array.isArray(cart.items)) throw new Error('Invalid cart');
        var qty = 0;
        var promoOriginalTotal = 0;
        var promoFinalTotal = 0;
        var hasBase = false, appliedTier = 0, stackedTier = 0;
        cart.items.forEach(function (item) {
          if (!isPromo(item)) return;
          if (!Number.isFinite(item.original_line_price) || !Number.isFinite(item.final_line_price)
              || item.original_line_price < 0 || item.final_line_price < 0 || !Number.isInteger(item.quantity) || item.quantity < 0) {
            throw new Error('Incomplete cart prices');
          }
          qty += item.quantity;
          promoOriginalTotal += item.original_line_price;
          promoFinalTotal += item.final_line_price;
          var applied = appliedPromotion(item);
          hasBase = hasBase || applied.base;
          appliedTier = Math.max(appliedTier, applied.tier);
          if (applied.base && applied.tier) stackedTier = Math.max(stackedTier, applied.tier);
        });
        currentTier = getCurrentTier(qty);
        var pct = currentTier ? currentTier.pct : 0;
        var actualSaved = Math.max(0, promoOriginalTotal - promoFinalTotal);

        // Fallback: if Shopify hasn't applied discount yet, calculate from tier
        if (actualSaved === 0 && pct > 0 && promoOriginalTotal > 0) {
          actualSaved = Math.round(promoOriginalTotal * pct / 100);
          promoFinalTotal = promoOriginalTotal - actualSaved;
        }

        if (discountBtn) {
          discountBtn.textContent = pct > 0 ? pct + '% OFF' : '0% OFF';
          discountBtn.classList.toggle('is-active', pct > 0);
        }

        if (originalEl) {
          originalEl.style.display = actualSaved > 0 ? '' : 'none';
          if (actualSaved > 0) originalEl.textContent = formatMoney(promoOriginalTotal);
        }
        if (totalEl) totalEl.textContent = formatMoney(actualSaved > 0 ? promoFinalTotal : promoOriginalTotal);
        if (savedEl) {
          savedEl.style.display = actualSaved > 0 ? '' : 'none';
          if (actualSaved > 0) savedEl.textContent = bt.saved + ' ' + formatMoney(actualSaved);
        }

        var progress = Math.min(qty, TIERS[2].qty);
        if (fillEl) fillEl.style.width = (progress / TIERS[2].qty * 100) + '%';
        if (gaugeEl) {
          gaugeEl.setAttribute('aria-label', bt.promo_progress_label || 'Promotion progress');
          gaugeEl.setAttribute('aria-valuenow', progress);
          gaugeEl.setAttribute('aria-valuetext', (bt.promo_progress || '{count} / 5').replace('{count}', qty));
        }

        nodes.forEach(function (node) {
          node.classList.toggle('is-active', qty >= parseInt(node.dataset.node, 10));
        });
        steps.forEach(function (step) {
          step.classList.toggle('is-active', qty >= parseInt(step.dataset.stepQty, 10));
        });

        hasConfirmedCart = true;
        bar.removeAttribute('hidden');
        bar.removeAttribute('aria-busy');
        if (barHidden) {
          var pct = currentTier ? currentTier.pct : 0;
          var closePct = lastTierAtClose ? lastTierAtClose.pct : 0;
          if (pct > closePct) showBar();
        }
        updateBodyPadding();
      })
      .catch(function () {
        // Hide stale or partial figures; retry on cart changes or when returning.
        if (generation === updateGeneration) {
          bar.setAttribute('hidden', '');
          bar.removeAttribute('aria-busy');
          updateBodyPadding();
        }
      });
  }

  // Update GWP labels with converted amount
  function updateGwpLabels(threshold) {
    var th = threshold || getGwpThreshold();
    var pcLabel = bar.querySelector('[data-pfbar-gwp-label]');
    var moLabel = bar.querySelector('[data-pfbar-gwp-label-mo]');
    if (barLang === 'ja') {
      if (pcLabel) pcLabel.innerHTML = formatMoney(th) + '<br>' + bt.free_bag;
      if (moLabel) moLabel.textContent = formatMoney(th) + ' ' + bt.free_bag;
    } else {
      if (pcLabel) pcLabel.innerHTML = bt.free_bag + '<br>' + bt.at + ' ' + formatMoney(th);
      if (moLabel) moLabel.textContent = bt.free_bag + ' ' + bt.at + ' ' + formatMoney(th);
    }
  }
  updateGwpLabels();
  function renderGwp(state) {
    updateGwpLabels(state.threshold);
    if (gwpFill) gwpFill.style.width = (state.progress || 0) + '%';
    if (gwpFillMo) gwpFillMo.style.width = (state.progress || 0) + '%';
    bar.setAttribute('data-gwp-status', state.status);
    bar.querySelectorAll('[data-gwp-node]').forEach(function (node) {
      node.classList.toggle('is-active', node.dataset.gwpNode === 'end' ? state.status === 'complete' : state.total > 0);
    });
    var message = window.VerishGwp ? window.VerishGwp.text(state, bt, formatMoney, 'free') : bt.gwp_unavailable || 'Gift status unavailable';
    [gwpText, gwpTextMo].forEach(function (node) {
      if (!node) return;
      node.textContent = message;
      node.classList.toggle('is-complete', state.status === 'complete');
    });
  }
  if (window.VerishGwp) window.VerishGwp.subscribe(renderGwp);
  else renderGwp({ status: 'unavailable', progress: 0 });

  update();
  window.addEventListener('focus', update);

  // Listen for cart updates
  if (typeof FoxTheme !== 'undefined' && FoxTheme.pubsub) {
    FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, update);
  }

  // Body padding to prevent content being hidden behind the bar
  function updateBodyPadding() {
    if (bar.style.display === 'none' || bar.hasAttribute('hidden')) {
      document.body.style.paddingBottom = '';
    } else {
      document.body.style.paddingBottom = bar.offsetHeight + 'px';
    }
  }
  updateBodyPadding();
  window.addEventListener('resize', updateBodyPadding);

  // Close / reopen — persisted via sessionStorage
  var STORAGE_KEY = 'pfbar_hidden';
  var STORAGE_TIER_KEY = 'pfbar_tier';
  var closeBtn = bar.querySelector('[data-pfbar-close]');
  var toggleBtn = document.querySelector('[data-pfbar-toggle]');
  var barHidden = false;
  var lastTierAtClose = 0;

  // Restore closed state from sessionStorage
  try {
    if (sessionStorage.getItem(STORAGE_KEY) === '1') {
      barHidden = true;
      bar.style.display = 'none';
      document.body.style.paddingBottom = '';
      if (toggleBtn) toggleBtn.style.display = 'flex';
      var storedTier = sessionStorage.getItem(STORAGE_TIER_KEY);
      if (storedTier) lastTierAtClose = JSON.parse(storedTier);
    }
  } catch (e) {}

  function hideBar() {
    bar.style.display = 'none';
    barHidden = true;
    document.body.style.paddingBottom = '';
    if (toggleBtn) toggleBtn.style.display = 'flex';
    lastTierAtClose = currentTier;
    try {
      sessionStorage.setItem(STORAGE_KEY, '1');
      sessionStorage.setItem(STORAGE_TIER_KEY, JSON.stringify(lastTierAtClose));
    } catch (e) {}
  }

  function showBar() {
    bar.style.display = '';
    barHidden = false;
    if (toggleBtn) toggleBtn.style.display = 'none';
    updateBodyPadding();
    try { sessionStorage.removeItem(STORAGE_KEY); sessionStorage.removeItem(STORAGE_TIER_KEY); } catch (e) {}
  }

  if (closeBtn) closeBtn.addEventListener('click', hideBar);
  if (toggleBtn) toggleBtn.addEventListener('click', showBar);

  // Re-open bar when discount tier upgrades
  if (typeof FoxTheme !== 'undefined' && FoxTheme.pubsub) {
    FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (barHidden && event && event.cart) {
        var q = 0;
        if (event.cart.items) event.cart.items.forEach(function (item) {
          if (promoIds.indexOf(item.product_id) !== -1 || (item.handle && item.handle.indexOf('-time-attack') !== -1)) q += item.quantity;
        });
        var newTier = getCurrentTier(q);
        var newPct = newTier ? newTier.pct : 0;
        var closePct = lastTierAtClose ? lastTierAtClose.pct : 0;
        if (newPct > closePct) showBar();
      }
    });
  }

})();
